<div aria-labelledby="name()+ 'Title'" >
        <p class="title"  [attr.data-qa] = "name() + '_label'" [attr.data-pw] = "name()+ '_label'" [id]="name()+'Title'">{{label()}}</p>
        @if (isMasked()) {
            <p class="details" [attr.data-qa] = "name()+ '_value'" [attr.data-pw] = "name()+ '_value'">{{ maskedString()}}{{ maskedValue() }}</p>
        }
        @else {
            <p class="details" [attr.data-qa] = "name()+ '_value'" [attr.data-pw] = "name()+ '_value'">{{ trueValue() | formatSSN }}</p>
        }
          <button class="svg-icon-wrapper icon" [attr.aria-label]="name()+'_maskButton'"  
                  [attr.data-qa] = "name()+ '_click'" [attr.data-pw] = "name()+ '_click'"
                  [disabled]="disabled()" [tabIndex]="tabIndex()" (click) = "isMasked.set(!isMasked())" (keyup)= "isMasked.set(!isMasked())" >
             <i class="icon fa-solid" [class]="isMasked() ? 'fa-eye' : 'fa-eye-slash'" [attr.data-pw]="label()+'_widget'" [attr.data-qa]="name()+'_icon'"></i>            
          </button> 
      </div>